import CitySEOHead from "@/components/feature/CitySEOHead";
import DubuqueHeroSection from "./components/HeroSection";
import DubuqueStickyNav from "./components/StickyNav";
import DubuqueProcessingTimeSection from "./components/ProcessingTimeSection";
import DubuqueServicesSection from "./components/ServicesSection";
import DubuqueLocalAreaSection from "./components/LocalAreaSection";
import DubuqueTestimonialsSection from "./components/TestimonialsSection";
import DubuqueAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import DubuqueComparisonSection from "./components/ComparisonSection";
import DubuqueMistakesSection from "./components/MistakesSection";
import DubuqueHowItWorksSection from "./components/HowItWorksSection";
import DubuqueFAQSection, { faqs } from "./components/FAQSection";
import DubuqueHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import DubuqueFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function DubuquePage() {
  return (
    <>
      <CitySEOHead
        city="Dubuque"
        state="Iowa"
        stateAbbr="IA"
        route="/cities/dubuque"
        title="Emergency Passport Dubuque, IA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Dubuque, IA — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Dubuque County, the Tri-State region, college students, and river cruise travelers."
        geoPlacename="Dubuque, Iowa"
        geoPosition="42.5006;-90.6646"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Iowa"
        statePageRoute="/states/iowa"
        serviceAreaDesc="Emergency and expedited passport services for Dubuque and the Tri-State area. As fast as 24 hours."
      />
      <div className="font-sans">
        <DubuqueHeroSection />
        <DubuqueStickyNav />
        <DubuqueProcessingTimeSection />
        <DubuqueLocalAreaSection />
        <DubuqueServicesSection />
        <DubuqueTestimonialsSection />
        <DubuqueAcceptanceFacilitiesSection />
        <DubuqueComparisonSection />
        <DubuqueMistakesSection />
        <DubuqueHowItWorksSection />
        <DubuqueFAQSection />
        <DubuqueHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/dubuque" state="IA" />
        <DubuqueFinalCTA />
      </div>
    </>
  );
}